import { __decorate } from "tslib";
import { mixins } from 'vue-class-component';
import { Component } from 'vue-property-decorator';
import { Mutation } from 'vuex-class';
let CartPromoMixin = class CartPromoMixin extends mixins() {
    goToCartPromosPage() {
        this.$router.push({ name: 'ecommerce-cart-promos' });
    }
};
__decorate([
    Mutation('requestOnFlight')
], CartPromoMixin.prototype, "mutationRequestOnFlight", void 0);
__decorate([
    Mutation('requestDone')
], CartPromoMixin.prototype, "requestDone", void 0);
CartPromoMixin = __decorate([
    Component
], CartPromoMixin);
export default CartPromoMixin;
